import { QRCodeSVG } from 'qrcode.react';
import { useState } from 'react';
import BlueDotsBackground from '../BlueDotsBackground';

const articles = [
  {
    title: 'Amplifying Pharma Technology Investments',
    date: '10/04/2026',
    author: 'Eduardo Goncalves',
    excerpt:
      'The pharmaceutical industry has made significant investments in revenue management technology over the last decade. Despite substantial spend on platforms such as Model N, many organizations continue to face operational challenges beyond the core capabilities of any single platform.',
    link: '/articles/AmplifyingPharmaTech',
  },
  {
    title: 'Responsible AI Adoption in a People-Centric Company',
    date: '10/04/2026',
    author: 'Eduardo Goncalves',
    excerpt:
      'Artificial intelligence is transforming the way organizations operate, but its greatest potential lies in amplifying human expertise rather than replacing it. At Kernel, our approach to AI is guided by a commitment to people, customers, and long-term value creation. We leverage AI to help customers, partners, and employees better understand complex Market Access, Finance, and Compliance processes while preserving the judgment, experience, and relationships that drive lasting success. As an independent company, we are pursuing AI innovation with discipline and purpose, investing in technologies that deliver meaningful outcomes while continuing to invest in talent, training, and customer success. We believe the future belongs to organizations that combine advanced technology with human expertise, creating better decisions, stronger partnerships, and sustainable growth.',
    link: '/articles/ResponsibleAiAdoption',
  },
  {
    title: 'MFP Impacts on Gross-to-Net Operations',
    date: '07/07/2025',
    author: 'Sushila Rau',
    excerpt:
      "Starting January 1, 2026, CMS will implement the initial set of Maximum Fair Prices (MFPs) for certain single-source drugs covered under Medicare Part D, as outlined in the Inflation Reduction Act. MFP impacts a manufacturer's Gross-to-Net (GTN) operations in several key ways.",
    link: '/articles/MfpGtn',
  },
  {
    title: 'MFP Impacts to Government Pricing',
    date: '06/20/2025',
    author: 'Sushila Rau',
    excerpt:
      'As manufacturers look to operationalize MFP effectuation, they must also understand the downstream consequences for Government Pricing (GP), financial liabilities, and compliance.',
    link: '/articles/MfpGp',
  },
  {
    title: 'MFP Long-Term Success',
    date: '06/10/2025',
    author: 'Josh Gingerich',
    excerpt:
      'With the first wave of MFP-covered drugs approaching, all nine impacted manufacturers have opted for an outsourced stopgap solution that focuses on the most immediate requirements for MFP.',
    link: '/articles/MfpLts',
  },
];

export default function Articles() {
  const [qrArticle, setQrArticle] = useState(null);

  // Full site URL is required so the QR code is scannable from any device.
  const articleUrl = (link) => `${window.location.origin}${link}`;

  return (
    <>
      <BlueDotsBackground />

      <section
        id="articles"
        className="min-h-screen py-20 px-6 text-white text-center"
      >
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold mb-12">Articles</h1>

          <div className="flex flex-col gap-6 text-left">
            {articles.map((article) => (
              <article
                key={article.link}
                className="bg-gray-900 border border-gray-700 rounded-xl p-6"
              >
                <h2 className="text-xl font-semibold text-white mb-1">
                  {article.title}
                </h2>
                <p className="text-sm text-gray-400 mb-3">
                  {article.date} &nbsp;|&nbsp; Written by {article.author}
                </p>
                <p className="text-gray-300 mb-4">{article.excerpt}</p>

                <div className="flex flex-wrap items-center gap-4">
                  <a
                    href={article.link}
                    className="inline-block bg-blue-600 hover:bg-blue-700 px-5 py-2 rounded-lg font-semibold transition"
                  >
                    Read Article
                  </a>
                  <button
                    type="button"
                    onClick={() => setQrArticle(article)}
                    className="inline-block border border-blue-500 text-blue-400 hover:bg-blue-600 hover:text-white px-5 py-2 rounded-lg font-semibold transition"
                  >
                    View QR Code
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {qrArticle && (
        <div
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 px-6"
          onClick={() => setQrArticle(null)}
        >
          <div
            className="bg-gray-900 border border-gray-700 rounded-xl p-8 flex flex-col items-center text-center max-w-sm"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-semibold text-white mb-4">
              {qrArticle.title}
            </h3>
            <div className="bg-white p-4 rounded-lg">
              <QRCodeSVG value={articleUrl(qrArticle.link)} size={200} />
            </div>
            <button
              type="button"
              onClick={() => setQrArticle(null)}
              className="mt-6 text-blue-400 hover:text-blue-300 font-semibold"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
